module.exports = __webpack_public_path__ + "img/homepage.de3efe09.webp";